// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wildlife-rpa-strike-hazards.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wildlife-rpa-strike-hazards/wildlife-rpa-strike-hazards.js';

mount([g0]);
